init_creative_content_tags = (select) ->
  $(select).select2 {
    templateResult: (state) =>
      obj = state.element;
      tooltip = if $(obj).attr('tooltip') then '<div class="select2-content-tag-tooltip">' + $(obj).attr('tooltip') + '</div>' else ''

      response = """
            <div>
              #{state.text}
              #{tooltip}
            </div>
          """

      return response

    templateSelection: (item) =>
      obj = item.element;
      tooltip = if $(obj).attr('tooltip') then $(obj).attr('tooltip') else false

      if tooltip
        text = $('<span>' + item.text + ' </span>').append('<i class="fa fa-info-circle opacity-dynamic"></i>').tooltip({title: tooltip, container: 'body'})
        return text
      else
        return item.text

    escapeMarkup: (m) =>
      return m;
  }

$(document).on 'init-global-scope', () =>
  init_creative_content_tags("#creative_content_tags")